module.exports = __webpack_public_path__ + "static/media/AlertIcon.011449bf.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Images/MessageBar/AlertIcon.svg
// module id = 1810
// module chunks = 0